import React, { useState, useEffect } from 'react';
import { fetchAcademicGroups, exportAcademicGroupsExcel } from '../services/academicFinanceApi';
import { FinanceTable } from './FinanceTable';
import Notifier from '../../../Utils/notify';
import exporticon from '../../../assets/icons/export-data.svg';

export const AcademicGroupsList = ({ specializationId, onAcademicGroupClick, onUpdateGrandTotals }) => {
  const [academicGroups, setAcademicGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [exporting, setExporting] = useState(false);
  const pageSize = 10;

  useEffect(() => {
    loadAcademicGroups(currentPage);
  }, [currentPage, specializationId]);

  const loadAcademicGroups = async (page) => {
    try {
      setLoading(true);
      const data = await fetchAcademicGroups(specializationId, page, pageSize);
      setAcademicGroups(data.results || []);
      
      if (data.grand_totals) {
        onUpdateGrandTotals(data.grand_totals);
      }
      
      if (data.count) {
        setTotalPages(Math.ceil(data.count / pageSize));
      }
    } catch (error) {
      console.error('Error loading academic groups:', error);
      Notifier.error('Failed to load academic groups');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      setExporting(true);
      await exportAcademicGroupsExcel(specializationId);
      Notifier.success('Academic groups data exported successfully');
    } catch (error) {
      console.error('Error exporting academic groups:', error);
      Notifier.error('Failed to export academic groups data');
    } finally {
      setExporting(false);
    }
  };

  const handleRowClick = (academicGroup) => {
    onAcademicGroupClick('least-academic-groups', academicGroup.id, academicGroup.name);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    { header: 'ID', accessor: 'id', width: '80px' },
    { header: 'Academic Group', accessor: 'name', width: '180px' },
    { header: 'Specialization', accessor: 'specialization_name', width: '180px' },
    { header: 'Course Name', accessor: 'course_name', width: '150px' },
    { header: 'Course Alias', accessor: 'course_alias', width: '100px' },
    { 
      header: 'Students', 
      accessor: 'total_students', 
      width: '100px',
      align: 'center'
    },
    { 
      header: 'Imposed', 
      accessor: 'total_imposed_fees', 
      width: '130px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Scheduled', 
      accessor: 'total_scheduled_fee', 
      width: '130px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Paid', 
      accessor: 'total_paid_fees', 
      width: '130px',
      align: 'right',
      format: 'currency'
    },
  ];

  return (
    <div className="academic-groups-list">
      <div className="list-header">
        <h2>Academic Groups</h2>
        <button 
          className="export-btn" 
          onClick={handleExport}
          disabled={exporting}
        >
          <img src={exporticon} alt="Export" />
          {exporting ? 'Exporting...' : 'Export'}
        </button>
      </div>

      <FinanceTable
        data={academicGroups}
        columns={columns}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
      />
    </div>
  );
};
